export const Props = () => ({
  //Текст кнопки
  text: { type: String }
});